import type { ReactNode } from "react";
import Chip from "@mui/material/Chip";
import SignalBadge, { type SignalTone } from "./SignalBadge";
import { CHIP_LABEL, chipToneClass } from "./format";

/** The rounded, tinted panel every trade/spread card sits in. */
export const CardShell = ({ children }: { children: ReactNode }) => (
  <div className="my-3 max-w-[728px] rounded-xl bg-tgpt-secondary-accentLight p-4 sm:p-5">{children}</div>
);

type CardHeaderProps = {
  ticker: string;
  companyName?: string;
  signal?: { label: string; tone: SignalTone } | null;
  expiry?: string | null;
};

export const CardHeader = ({ ticker, companyName, signal, expiry }: CardHeaderProps) => (
  <div className="flex items-start justify-between gap-2">
    <div className="flex items-baseline gap-2">
      <span className="text-lg font-bold text-token-text-primary">{ticker}</span>
      {companyName && <span className="text-sm text-token-text-secondary">{companyName}</span>}
    </div>
    {(signal || expiry) && (
      <div className="flex items-center gap-1.5">
        {signal && <SignalBadge label={signal.label} tone={signal.tone} />}
        {expiry && (
          <Chip size="small" label={expiry} className={`!rounded-full ${CHIP_LABEL} ${chipToneClass("neutral")}`} />
        )}
      </div>
    )}
  </div>
);
